export default __webpack_public_path__ + "static/frame-001-b453acb5fbdae173221ca541b3682965.png";